// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__CNzLJ","indicator":"checkbox_indicator__pQLKz","icon":"checkbox_icon__4JKwF"};